import React, {useEffect, useState, useContext} from 'react'
import {Container, Button, Grid, Typography, Box, Card, Radio} from '@material-ui/core'
import BarcodeNavHeaderButtons from '../BarcodeNavHeaderButtons'
import {useTranslation} from 'react-i18next'
import BarcodeWizardPreview from '../BarcodeWizardPreview'
import useStyles from './BarcodeWizardGenerateSetting.styles'
import {BarcodeLabelRecordContext} from '../../context/BarcodeLabelRecord'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'
import {ToastMessageContext} from '../../context/ToastMessage'
import {UserContext} from '../../context/UserContext'
import {validateBarcodePermission} from '../../modules/common/utils/permissions'

function BarcodeWizardGenerateSetting(props) {
  const classes = useStyles()
  const {history} = props
  const {t} = useTranslation()
  const [selectedValue, setSelectedValue] = useState('')
  const {barcodeLabelRecord} = useContext(BarcodeLabelRecordContext)
  const {barcodeSheetRecord} = useContext(BarcodeSheetRecordContext)
  const toast = useContext(ToastMessageContext)
  const currentUser = React.useContext(UserContext)

  useEffect(() => {
    if (!!!barcodeLabelRecord || !!!barcodeSheetRecord) {
      history.replace({
        pathname: 'barcode-wizard',
      })
    }
  }, [barcodeLabelRecord, barcodeSheetRecord, history])

  useEffect(() => {
    if (window !== window.parent) {
      window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  function clickContinue(event) {
    if(!validateBarcodePermission(currentUser, "can_add")){
      toast.popMessage(
        t('barcode.wizard.generate-setting.permission-issue'),
        'warning',
        event.currentTarget
      )
      return;
    }
    if (!selectedValue) {
      toast.popMessage(
        t('barcode.wizard.generate-setting.what-to-generate'),
        'warning',
        event.currentTarget
      )
    } else {
      props.history.push({
        pathname: selectedValue,
      })
    }
  }

  function handleChange(event) {
    setSelectedValue(event.target.value)
  }

  return (
    <div>
      <BarcodeNavHeaderButtons previous="barcode-wizard" />

      <Grid container>
        <Grid item xs={6}>
          <Container>
            <Card>
              <Grid container>
                <Grid container item xs={10} justify="flex-start">
                  <Typography variant="h5">
                    <Box marginTop={3} marginLeft={3}>
                      {t('barcode.wizard.generate-setting.automatic-generate')}
                    </Box>
                  </Typography>
                </Grid>
                <Grid container item xs={2} justify="flex-end" className={classes.radioSpacing}>
                  <Radio
                    checked={selectedValue === 'barcode-wizard-auto-form'}
                    onChange={handleChange}
                    color="primary"
                    value="barcode-wizard-auto-form"
                  />
                </Grid>
              </Grid>
              <Box marginTop={2} marginBottom={5} marginLeft={3} marginRight={1} fontWeight={400}>
                {t('barcode.wizard.generate-setting.setting-details')}
              </Box>
            </Card>

            <Card className={classes.cardSpacing}>
              <Grid container>
                <Grid container item xs={10} justify="flex-start">
                  <Typography variant="h5">
                    <Box marginTop={3} marginLeft={3}>
                      {t('barcode.wizard.generate-setting.generate-field')}
                    </Box>
                  </Typography>
                </Grid>
                <Grid container item xs={2} justify="flex-end" className={classes.radioSpacing}>
                  <Radio
                    checked={selectedValue === 'barcode-wizard-field-value-form'}
                    onChange={handleChange}
                    color="primary"
                    value="barcode-wizard-field-value-form"
                  />
                </Grid>
              </Grid>

              <Box marginTop={2} marginBottom={2} marginLeft={3} fontWeight={400}>
                {t('barcode.wizard.generate-setting.setting-option')}
              </Box>
              <Container>
                <Card className={classes.infoBackground}>
                  <Box
                    fontWeight={350}
                    fontStyle="italic"
                    marginTop={2}
                    marginBottom={2}
                    marginLeft={2}
                    marginRight={1}
                  >
                    <Box fontWeight={600} display={'inline'}>
                      {t('barcode.wizard.generate-setting.ex')}
                    </Box>{' '}
                    <Box display={'inline'}>{t('barcode.wizard.generate-setting.asset-data')}</Box>
                    <Box>{t('barcode.wizard.generate-setting.existing-data')}</Box>
                  </Box>
                </Card>
              </Container>

              <Box marginTop={2} marginBottom={5} marginLeft={3} marginRight={1}>
                {t('barcode.wizard.generate-setting.choose-data')}
              </Box>
            </Card>

            <Grid container justify="flex-end">
              <Button
                variant="contained"
                color="primary"
                onClick={clickContinue}
                style={{textTransform: 'none'}}
                disabled = {!validateBarcodePermission(currentUser, "can_add")}
              >
                {t('barcode.wizard.generate-setting.continue')}
              </Button>
            </Grid>
          </Container>
        </Grid>

        <Grid item xs={6}>
          <BarcodeWizardPreview />
        </Grid>
      </Grid>
    </div>
  )
}

export default BarcodeWizardGenerateSetting
